import React from 'react';

export const LazyDashboardChart = React.lazy(() => import('./DashboardChartPage'));

export const LazyDashboard3d = React.lazy(() => import('./Dashboard3dPage'));
